<template>
    <b-confirm :text="text" :title="title" :hide-true-btn="hideTrueBtn" @true="triggerDelete">
        <template #button="{ on, dialog }">
            <v-btn icon color="disabled-color" @click="dialog = true" v-on="on">
                <v-icon v-if="icon !== null">{{ icon }}</v-icon>
            </v-btn>
        </template>
    </b-confirm>
</template>

<script>
export default {
    props: {
        path: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: false,
            default: () => {
                return t('default::confirmation.simple');
            },
        },
        text: {
            type: String,
            required: false,
            default: () => {
                return t('default::confirmation.item_removal');
            },
        },
        btnText: {
            type: String,
            required: false,
            default: () => {
                return t('default::button.delete');
            },
        },
        hideTrueBtn: {
            type: Boolean,
            required: false,
            default: false,
        },
        icon: {
            type: String,
            required: false,
            default: () => {
                return null;
            },
        },
    },
    methods: {
        triggerDelete() {
            axios.delete(this.path).then(() => {
                this.$emit('deleted');
            });
        },
    },
};
</script>

<style scoped></style>
